/**
 * Beer must be ordered in multiples of 12. The +/- steppers already respect
 * the input's native `step`/`min` attributes (see QuantityInput in global.js),
 * so this only needs to catch values typed directly into the field.
 */
(function () {
  function nearestValidQuantity(input) {
    const multiple = parseInt(input.dataset.orderMultiple, 10);
    const min = parseInt(input.min, 10) || multiple;
    const value = parseInt(input.value, 10) || 0;

    if (value < min) return min;
    if (value % multiple === 0) return value;
    return Math.max(min, Math.round(value / multiple) * multiple);
  }

  function announce(input, corrected) {
    const wrapper = input.closest('.quantity-popover-wrapper, .price-per-item__container') || input.parentElement;
    if (!wrapper) return;

    let message = wrapper.querySelector('.order-multiple-guard__message');
    if (!message) {
      message = document.createElement('p');
      message.className = 'order-multiple-guard__message caption';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      wrapper.appendChild(message);
    }

    const multiple = input.dataset.orderMultiple;
    message.textContent = `Beer is sold in cases of ${multiple} — quantity adjusted to ${corrected}.`;
    window.clearTimeout(message._hideTimeout);
    message._hideTimeout = window.setTimeout(() => {
      message.remove();
    }, 6000);
  }

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!input.matches || !input.matches('.quantity__input[data-order-multiple]')) return;

      const corrected = nearestValidQuantity(input);
      if (String(corrected) !== input.value) {
        input.value = corrected;
        announce(input, corrected);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const input = event.target.querySelector && event.target.querySelector('.quantity__input[data-order-multiple]');
      if (!input) return;

      const corrected = nearestValidQuantity(input);
      if (String(corrected) !== input.value) {
        input.value = corrected;
        announce(input, corrected);
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
